import { render, staticRenderFns } from "./MaterielPicture.vue?vue&type=template&id=166f448c&scoped=true&"
import script from "./MaterielPicture.vue?vue&type=script&lang=js&"
export * from "./MaterielPicture.vue?vue&type=script&lang=js&"
import style0 from "./MaterielPicture.vue?vue&type=style&index=0&id=166f448c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166f448c",
  null
  
)

export default component.exports